/**
 * VCB — sonda degli errori del sito.
 *
 * Registra in GA4 tre cose che oggi non sappiamo:
 *   vcb_js_error      errori JavaScript e promesse rifiutate
 *   vcb_page_crash    la pagina precedente e' morta senza chiudersi (renderer OOM)
 *   vcb_empty_results collezione o ricerca che non mostra nessun prodotto
 *
 * Perche' il crash si rileva DOPO e non mentre accade: quando il renderer
 * esaurisce la memoria il processo viene ucciso, e con lui il JavaScript che
 * dovrebbe segnalarlo. L'unico modo e' lasciare un segnale all'avvio e
 * cancellarlo su `pagehide` (che scatta a ogni uscita pulita, navigazione o
 * bfcache). Se al caricamento dopo il segnale e' ancora li', la pagina prima e'
 * morta male.
 *
 * ⚠️ Falsi positivi possibili: chiusura forzata del browser, spegnimento,
 * scheda uccisa dal sistema su mobile. Serve a contare e a capire DOVE, non a
 * dimostrare il singolo caso.
 *
 * Privacy: nessun dato personale. Si manda il PERCORSO senza query string (che
 * puo' contenere termini di ricerca), il messaggio d'errore troncato, e nulla
 * che identifichi la persona.
 *
 * Robustezza: tutto dentro try/catch e con un tetto di eventi per pagina. Una
 * sonda che rompe il sito o inonda GA4 e' peggio di nessuna sonda.
 */
(function () {
  'use strict';

  var CHIAVE = 'vcb_nav';
  var MAX_EVENTI = 3; // tetto per caricamento: un loop di errori non deve inondare
  var inviati = 0;

  function percorso() {
    try {
      return (location.pathname || '/').slice(0, 120); // senza query: puo' contenere ricerche
    } catch (e) {
      return '/';
    }
  }

  /**
   * Ultimo segmento di una URL, SENZA query string.
   * ⚠️ La query va tolta anche qui, non solo da `page_path`: un errore dentro
   * uno script inline ha come `filename` la URL della pagina, quindi su
   * /search?q=... finirebbe in GA4 il termine cercato dall'utente.
   * Trovato provando la sonda il 21/08/2026.
   */
  function senzaQuery(u) {
    try {
      return String(u || '').split('?')[0].split('#')[0].split('/').pop().slice(0, 60);
    } catch (e) {
      return '';
    }
  }

  function invia(nome, dati) {
    try {
      if (inviati >= MAX_EVENTI) return;
      inviati++;
      window.dataLayer = window.dataLayer || [];
      dati = dati || {};
      dati.page_path = percorso();
      // dataLayer accetta i comandi anche prima che gtag.js sia pronto:
      // vengono eseguiti in coda quando l'app Google carica.
      window.dataLayer.push(['event', nome, dati]);
    } catch (e) {
      /* la sonda non deve mai far cadere la pagina */
    }
  }

  /* ---------------------------------------------- 1. errori JavaScript */
  window.addEventListener('error', function (ev) {
    try {
      if (!ev) return;
      // Gli errori di caricamento risorsa (img/script) non hanno `message`:
      // sono rumore diverso, li marchiamo a parte.
      if (!ev.message && ev.target && ev.target.tagName) {
        invia('vcb_js_error', {
          err_tipo: 'risorsa',
          err_msg: String(ev.target.tagName).slice(0, 20),
          err_src: senzaQuery(ev.target.src || ev.target.href)
        });
        return;
      }
      invia('vcb_js_error', {
        err_tipo: 'script',
        err_msg: String(ev.message || '').slice(0, 100),
        err_src: senzaQuery(ev.filename) + ':' + (ev.lineno || 0)
      });
    } catch (e) {}
  }, true);

  window.addEventListener('unhandledrejection', function (ev) {
    try {
      var r = ev && ev.reason;
      invia('vcb_js_error', {
        err_tipo: 'promessa',
        err_msg: String((r && (r.message || r)) || '').slice(0, 100),
        err_src: ''
      });
    } catch (e) {}
  });

  /* ------------------------------------- 2. la pagina prima e' morta? */
  try {
    var prec = sessionStorage.getItem(CHIAVE);
    if (prec) {
      var p = JSON.parse(prec);
      // Se il segnale e' ancora qui, `pagehide` non e' mai scattato.
      invia('vcb_page_crash', {
        crash_page: String(p.p || '').slice(0, 120),
        crash_durata_s: p.t ? Math.round((Date.now() - p.t) / 1000) : 0
      });
    }
    sessionStorage.setItem(CHIAVE, JSON.stringify({ p: percorso(), t: Date.now() }));
    window.addEventListener('pagehide', function () {
      try {
        sessionStorage.removeItem(CHIAVE);
      } catch (e) {}
    });
  } catch (e) {
    /* sessionStorage puo' essere negato (navigazione privata, cookie bloccati) */
  }

  /* --------------------------------------- 3. pagine senza risultati */
  window.addEventListener('load', function () {
    try {
      var p = percorso();
      if (p.indexOf('/collections/') !== 0 && p.indexOf('/search') !== 0) return;
      // Si guarda la griglia dei risultati, non tutta la pagina: i caroselli
      // di raccomandazione contengono prodotti anche quando la griglia e' vuota.
      var griglia = document.querySelector('#ResultsList, .main-collection-grid');
      if (!griglia) return;
      if (griglia.querySelectorAll('a[href*="/products/"]').length === 0) {
        invia('vcb_empty_results', { tipo: p.indexOf('/search') === 0 ? 'ricerca' : 'collezione' });
      }
    } catch (e) {}
  });
})();
